<template>
  <div v-if="showSearchInput">
    <div
      class="popup-wrap popup-lobby"
      :class="{ active: showSearchInput }"
    >
      <div class="popup-box">
        <div class="content">
          <div class="top">
            <div class="title">
              <h3>{{ $t("Bao.search_game") }}</h3>
              <a class="popup-close" @click="hide" />
            </div>
            <div class="search-input">
              <input v-model="searchText" type="text" :placeholder="$t('Bao.find_game')">
            </div>
            <div class="trending-tags">
              <button
                v-for="(keyWord, key) in $store.getters.searchKeyWord.game"
                :key="key"
                class="button-style-11"
                @click="setSearchText(keyWord)"
              >
                <span>{{ keyWord }}</span>
              </button>
            </div>
          </div>
          <div class="search-result">
            <div
              v-for="(item, key) in (searchText === '' ? filterResult.slice(0, 40) : filterResult)"
              :key="key"
              class="search-game-info"
              :class="{ active: item.id === selectedGame.id }"
            >
              <div class="search-game-text" @click="apply(item)">
                <i>
                  <picture><img :src="item.image" alt="Images of Search Games"></picture>
                </i>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-lobby">
      <div class="top">
        <div class="title">
          <h3>{{ $t("Bao.search_game") }}</h3>
          <a class="popup-close" @click="hide" />
        </div>
        <div class="search-input">
          <input
            ref="searchInput"
            v-model="searchText"
            type="text"
            :placeholder="$t('Bao.find_game')"
          >
        </div>
        <div class="trending-tags">
          <button v-for="(keyWord, key) in $store.getters.searchKeyWord.game" :key="key" class="button-style-11" @click="setSearchText(keyWord)">
            <span>{{ keyWord }}</span>
          </button>
        </div>
      </div>
      <div class="content">
        <div class="search-result">
          <div v-for="(item, key) in (searchText === '' ? filterResult.slice(0, 40) : filterResult)" :key="key" class="search-game-info" :class="{ active: item.id === selectedGame.id }">
            <div class="search-game-text" @click="apply(item)">
              <i>
                <picture><img :src="item.image" alt="Flowers"></picture>
              </i>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { launchGameWithProviderInfo } from '@/utils/games'
import { getGameList } from '@/api/game'
import { mapGetters } from 'vuex'
import { detectMob } from '@/utils/tool'

export default {
  name: 'SearchGame',
  props: {
    allGame: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      showSearch: false,
      searchText: '',
      selectedGame: {},
      gamePlayHistory: []
    }
  },
  computed: {
    ...mapGetters(['gameIdsArray']),
    gameIdSet() {
      return new Set(this.gameIdsArray.map(gameObj => gameObj.game_id))
    },
    gameIndexMap() {
      return new Map(this.gameIdsArray.map((gameObj, index) => [gameObj.game_id, index]))
    },
    filterResult() {
      if (this.searchText === '') { // 沒有輸入關鍵字，顯示全部遊戲
        if (this.gameIdSet.size === 0) { // 沒有遊玩紀錄，顯示全部遊戲
          return this.allGame
        } else { // 顯示遊玩紀錄
          return this.gamePlayHistory // gamelist API資料
        }
      } else { // 輸入關鍵字
        const searchTextLowerCase = this.searchText.toLowerCase()

        return this.allGame.filter((game) => {
          if (!game || !game.multiple || !game.multiple.name) {
            return false
          }

          if (typeof game.multiple.name !== 'object' || game.multiple.name === null) {
            return false
          }

          try {
            return Object.values(game.multiple.name).some(gameName => {
              return typeof gameName === 'string' && gameName.toLowerCase().includes(searchTextLowerCase)
            })
          } catch (error) {
            console.error('Error processing game:', game, error)
            return false
          }
        })
      }
    },
    showSearchInput() {
      return this.$store.state.brand.showSearch
    }
  },
  watch: {
    showSearchInput(newVal) {
      if (!newVal) {
        this.searchText = ''
      } else {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }

      this.selectedGame = {}
    },
    '$store.state.app.gameIdsArray'(to) {
      if (to && to.length) {
        this.fetchGameList()
      }
    }
  },
  created() {
    this.fetchGameList()
  },
  methods: {
    filterAndSortGames() {
      const filteredGames = this.allGame.filter(game => this.gameIdSet.has(game.id))
      return filteredGames.sort((a, b) => this.gameIndexMap.get(b.id) - this.gameIndexMap.get(a.id))
    },
    fetchGameList() {
      const gamesArr = Array.from(this.gameIdSet)
      if (gamesArr.length === 0) {
        return
      }

      getGameList({ game_id_list_string: JSON.stringify(gamesArr) })
        .then((response) => {
          this.gamePlayHistory = response.data.data
          this.$store.commit('SET_GAME_RECORD', this.gamePlayHistory)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    apply(item) {
      launchGameWithProviderInfo(item)
      this.showSearch = false
      this.$store.commit('SET_SHOW_RESEARCH', false)
      this.searchText = ''
      this.selectedGame = {}
    },
    setSearchText(keyWord) {
      this.searchText = keyWord
    },
    hide() {
      this.showSearch = false
      this.$store.commit('SET_SHOW_RESEARCH', false)
      this.selectedGame = {}
      this.searchText = ''
    },
    clearSearchText() {
      this.searchText = ''
    },
    isMobile() {
      return detectMob()
    },
    smoothBehavior(refName) {
      this.$nextTick(() => {
        this.$refs[refName].scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    }
  }
}
</script>

<style scoped>
</style>
